export enum WalletConnectState {
    CONNECTED = "CONNECTED",
    ALREADY_CONNECTED = "ALREADY_CONNECTED"
}